// The project page's whole-dollar money format, moved here unchanged from
// project-detail.tsx (2026-10-01) so the Sub payment box can render it from its
// own file and be tested without loading the page. ⛔ It is NOT
// shared/format.ts's fmtCurrency: that one returns '' for null where this
// returns '—', and the page's text must not change.
export function fmtCurrency(n: number | null | undefined): string {
  if (n == null) return '—';
  return `$${n.toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}
